// extracted by mini-css-extract-plugin
module.exports = {"opreation-button":"opreation-button-ce7b6e81f521de51712e90e7a0118809"};